import React, { useEffect, useState} from 'react';
import PasskeySignin from '../PasskeySignin/PasskeySignin';
import Clock from '../Clock/Clock';

const Main = () => {
    const [authenticate, setAuthenticate] = useState(false);
    const [load, setLoad] = useState(false);

    useEffect(() => {
        const checkAuth = async () => {
            try {
                const res = await fetch("https://server.ben-bea.com/protected", {
                    method:"GET",
                    credentials:"include"
                });

                if (res.ok) {
                    setAuthenticate(true);
                }
                else {
                    setAuthenticate(false);
                }
            }
            catch (err) {
                setAuthenticate(false);
            }
            setLoad(true);
        }

        checkAuth();
    },[]);

    return (
        <>
            {
                load ?
                (
                    authenticate ? 
                    (
                        <div className='home-container'>
                            <Clock></Clock>
                        </div>  
                    ) 
                    :
                    (
                        <div>
                            <PasskeySignin onLoginSuccess={() => setAuthenticate(true)}></PasskeySignin>
                        </div>
                    )
                )
                :
                (
                    <p></p>
                )
            }
        </>
    )
};

export default Main;